import React from 'react';
import PropTypes from 'prop-types';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { injectIntl } from 'react-intl';
import intlShape from '@/shared/utils/intlShape';
import messages from './trainingMessages';

const TrainingCertificateMissingIcon = ({ intl, id }) => (
  <OverlayTrigger
    placement="top"
    overlay={
      <Tooltip id={`training-certificate-missing-warning${id || ''}`}>
        {intl.formatMessage(messages.CertificateMissing)}
      </Tooltip>
    }
  >
    <i className="fa fa-exclamation-triangle fa-fw text-danger" />
  </OverlayTrigger>
);

TrainingCertificateMissingIcon.propTypes = {
  intl: intlShape.isRequired,
  id: PropTypes.string,
};

TrainingCertificateMissingIcon.defaultProps = {
  id: undefined,
};

export default injectIntl(TrainingCertificateMissingIcon);
